// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3uQJI","footer":"ChangeClinic_footer__36tl8"};